import React, { useRef } from 'react';
import './HeaderCell.less';
import { Typography } from 'antd';

const { Text } = Typography;

const CustomHeaderCell = ({ label, sortIconElement, onSort, onColumnResize, dataKey, disableSort, sortDirection }) => {
  const headerRef = useRef(null);
  const startX = useRef(0);
  const startWidth = useRef(0);

  const handleMouseDown = (e) => {
    e.stopPropagation();
    startX.current = e.clientX;
    startWidth.current = headerRef.current.offsetWidth;

    const handleMouseMove = (moveEvent) => {
      const newWidth = Math.max(startWidth.current + (moveEvent.clientX - startX.current), 50);
      onColumnResize({ dataKey, newWidth });
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <div ref={headerRef} className="oc-fm--header-cell" style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
      <Text
        style={{ cursor: disableSort ? 'default' : 'pointer', flexGrow: 1 }}
        onClick={(e) => {
          e.stopPropagation();
            if (onSort && !disableSort) {
            const newSortDirection = sortDirection === 'ASC' ? 'DESC' : 'ASC';

            onSort({ sortBy: dataKey, sortDirection: newSortDirection });
          }
        }}
      >
        {label} {sortIconElement}
      </Text>
      <div style={{ width: '5px', cursor: 'col-resize', position: 'absolute', right: 0, top: 0, bottom: 0 }} onMouseDown={handleMouseDown} />
    </div>
  );
};

export default CustomHeaderCell;
